import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'
import { ContentCopy } from '@mui/icons-material'
import { IconButton, TextField, Tooltip, Typography } from '@mui/material'

import { NoticeModal } from 'src/components/Modal/NoticeModal'
import { ModalApiKeyContext } from 'src/context/ModalCreatedApiKeyContext'
import { NoteCard } from 'src/components/NoteCard/NoteCard'

export const ModalCreatedApiKey = () => {
  const { t } = useTranslation()
  const { open, id, handleCloseModal } = useContext(ModalApiKeyContext)

  const information = t('modal.apikey.content.information', { interpolation: { escapeValue: false } });

  return (
    <NoticeModal
      type="success"
      children={
        <TextField
          value={id}
          disabled
          sx={{
            fontSize: '14px',
            width: '100%',
          }}
          InputProps={{
            endAdornment: (
              <Tooltip title={t('modal.apikey.content.copy')} placement="left">
                <IconButton
                  onClick={() => copy(id)}
                  sx={{
                    borderRadius: '4px',
                    minWidth: '32px',
                    color: '#00000099',
                    ':hover': {
                      color: 'white',
                      backgroundColor: '#00000099',
                    },
                  }}
                >
                  <ContentCopy />
                </IconButton>
              </Tooltip>
            ),
          }}
        />
      }
      title={t('modal.apikey.content.title')}
      subtitle={
        <>
          <NoteCard
            title={t('modal.apikey.content.subtitle')}
            content={
              <Typography variant="body2" sx={{ color: '#000', textAlign: 'left' }}>
               {information.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </Typography>
            }
          />
        </>
      }
      open={open}
      handleClose={() => handleCloseModal(!open)}
    />
  )
}
